/* bs-faq-help — accordion animado para los FAQ items.
   Intercepta el toggle nativo de <details>/<summary> y anima height para abrir/cerrar.
   Mantiene la semantica de <details> para keyboard/screen readers. */

(function () {
  'use strict';

  function setupCard(card) {
    const summary = card.querySelector('.bs-faq-help__faq-summary');
    const answer = card.querySelector('.bs-faq-help__faq-answer');
    if (!summary || !answer) return;

    let animating = false;

    function clearTransitionEnd(handler) {
      answer.removeEventListener('transitionend', handler);
    }

    function animateOpen() {
      animating = true;
      // [open] activa el contenido; el browser lo monta a auto height.
      card.setAttribute('open', '');
      // Medimos altura real que tendria el contenido.
      const target = answer.scrollHeight;
      // Bajamos a 0 inline (override el auto que aplico el browser).
      answer.style.height = '0px';
      // Doble rAF para forzar 2 frames: 1) flush 0px, 2) transicion al target.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          answer.style.height = target + 'px';
        });
      });

      function onEnd(e) {
        if (e.propertyName !== 'height') return;
        clearTransitionEnd(onEnd);
        // Quitamos inline height para que crezca naturalmente si content cambia.
        answer.style.height = '';
        animating = false;
      }
      answer.addEventListener('transitionend', onEnd);
    }

    function animateClose() {
      animating = true;
      // Fijamos altura actual antes de bajar a 0 (auto no es transitionable).
      const start = answer.scrollHeight;
      answer.style.height = start + 'px';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          answer.style.height = '0px';
        });
      });

      function onEnd(e) {
        if (e.propertyName !== 'height') return;
        clearTransitionEnd(onEnd);
        // Removemos [open] al final de la animacion (no antes — sino el browser oculta el contenido).
        card.removeAttribute('open');
        answer.style.height = '';
        animating = false;
      }
      answer.addEventListener('transitionend', onEnd);
    }

    summary.addEventListener('click', function (event) {
      // Bloqueamos el toggle nativo del browser; lo manejamos nosotros.
      event.preventDefault();
      if (animating) return;
      if (card.hasAttribute('open')) {
        animateClose();
      } else {
        animateOpen();
      }
    });

    // Soporte keyboard (Enter/Space ya disparan el click event en summary, OK).
  }

  function init(root) {
    const cards = (root || document).querySelectorAll('.bs-faq-help__faq-card');
    cards.forEach(function (card) {
      if (card.__bsFaqHelpInit) return;
      card.__bsFaqHelpInit = true;
      setupCard(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.bs-faq-help');
    if (section) init(event.target);
  });
})();
